import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const cities:SchemaTableOptions = {
    name:<string> 'cities',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'province_id', value: 'INTEGER UNSIGNED'},
        { column: 'code', value: 'VARCHAR(255) NOT NULL'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}